<template>
  <div>
    <the-nav-bar :title="$t('rebate.name')" />
    <div class="skeleton-wrapper" v-if="!isLoaded">
      <md-skeleton title :row="6"></md-skeleton>
      <md-skeleton title :row="4"></md-skeleton>
    </div>
    <div class="body-wrapper" v-else>
      <div class="header">
        <a href="#/mine/commission/rules">
          <img
            :src="require(`./banner-${navLangMain}.png`)"
            class="banner"
          />
        </a>
        <div class="ratio">
          <div class="ratio-left">
            <div class="ratio-item">
              <div class="ratio-title">{{ $t('rebate.groupRatio') }}</div>
              <div class="ratio-content num-font">
                {{ userInfo.userGroupInviteRate | formatPercent
                }}<span class="small">%</span>
              </div>
            </div>
            <div class="ratio-item">
              <div class="ratio-title">{{ $t('rebate.inviteRatio') }}</div>
              <div class="ratio-content num-font">
                {{ userRate | formatPercent }}<span class="small">%</span>
              </div>
            </div>
          </div>
          <div class="division"></div>
          <div class="ratio-right">
            <div class="ratio-item">
              <div class="ratio-title">{{ $t('rebate.friendsRatio') }}</div>
              <div class="ratio-content num-font">
                {{ inviteeRate | formatPercent }}<span class="small">%</span>
              </div>
            </div>
            <div class="ratio-item">
              <div class="btn row-center" @click="onShare">
                {{ $t('rebate.inviteNow') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <md-tab-bar
        class="tab-bar"
        :items="tabBarItems"
        @change="onTabChanged"
        v-model="currentTab"
      />
      <div class="content-wrapper">
        <div
          class="content"
          :style="`transform: translate(${contentTransformX}, 0)`"
        >
          <div class="pane total-pane">
            <div class="box">
              <md-radio-group v-model="current" @input="onChecked">
                <md-radio-box
                  v-for="item in radioList"
                  :key="item.name"
                  :name="item.name"
                  :label="item.label"
                ></md-radio-box>
              </md-radio-group>
            </div>
            <div class="detail">
              <div class="detail-header row-justify-center">
                <div class="detail-header-left">
                  {{ $t('rebate.estimated') }}
                </div>
                <div class="detail-header-right">
                  <span class="num">{{ allCommission }}</span> USDT
                </div>
              </div>
              <div class="detail-body">
                <div class="body-item row-justify-center">
                  <div class="body-item-left">{{ $t('rebate.orderNum') }}</div>
                  <div class="body-item-right">
                    <b>{{ orderCount }}</b>
                  </div>
                </div>
                <div class="body-item row-justify-center">
                  <div class="body-item-left">{{ $t('rebate.customers') }}</div>
                  <div class="body-item-right">
                    <b>{{ userCount }}</b>
                  </div>
                </div>
              </div>
              <div class="detail-footer row-justify-center">
                <div
                  class="detail-footer-left row-align-center"
                  v-if="hasRankList"
                >
                  <svg class="icon"><use xlink:href="#icon-cup" /></svg>
                  <span>
                    {{ $t('rebate.ranking') }}
                    <b class="strong">{{ ranking }}</b></span
                  >
                </div>
                <div v-else></div>
                <router-link
                  tag="div"
                  to="/mine/commission/rank"
                  class="detail-footer-right row-align-center"
                >
                  <svg class="icon"><use xlink:href="#icon-chart" /></svg>
                  <span>{{ $t('rebate.viewRank') }}</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="pane invite-pane">
            <div class="box-wrapper" v-if="!isEdit">
              <div class="box">
                <div class="item row-justify-center">
                  <div class="item-left">
                    {{
                      `${$t('rebate.inviterRatio')}/${$t(
                        'rebate.inviteeRatio',
                      )}`
                    }}
                  </div>
                  <div class="item-right">
                    {{ userRate | formatPercent }}%/{{
                      inviteeRate | formatPercent
                    }}%
                  </div>
                </div>
                <div class="item row-justify-center">
                  <div class="item-left">{{ $t('rebate.inviteCode') }}</div>
                  <div
                    class="item-right row-center"
                    @click="$copyText(userInfo.inviteCode)"
                  >
                    <span class="text">{{ userInfo.inviteCode }}</span>
                    <svg class="icon"><use xlink:href="#icon-copy" /></svg>
                  </div>
                </div>
                <div class="item row-justify-center">
                  <div class="item-left">{{ $t('rebate.inviteLink') }}</div>
                  <div
                    class="item-right row-center"
                    @click="$copyText(inviteLink)"
                  >
                    <span class="text">{{ inviteLink }}</span>
                    <svg class="icon"><use xlink:href="#icon-copy" /></svg>
                  </div>
                </div>
                <div class="item row-justify-center">
                  <div class="item-left">{{ $t('rebate.inviteNum') }}</div>
                  <div class="item-right">{{ userInfo.inviteeCount }}</div>
                </div>
              </div>
              <div class="btn-group">
                <div
                  class="btn plain primary row-center"
                  @click="onEditBtnClick"
                >
                  {{ $t('rebate.edit') }}
                </div>
                <div class="btn primary row-center" @click="onShare">
                  {{ $t('rebate.invite') }}
                </div>
              </div>
            </div>
            <div class="box-wrapper" v-else>
              <div class="box">
                <div class="row">
                  <div class="info">
                    <div class="info-title">
                      {{ $t('rebate.inviterRatio') }}
                    </div>
                    <div class="info-num num-font">
                      {{ editUserRate | formatPercent
                      }}<span class="small">%</span>
                    </div>
                  </div>
                  <div class="info">
                    <div class="info-title">
                      {{ $t('rebate.inviteeRatio') }}
                    </div>
                    <div class="info-num num-font">
                      {{ editInviteeRate | formatPercent
                      }}<span class="small">%</span>
                    </div>
                  </div>
                </div>
                <md-radio-group
                  v-model="currentPercent"
                  class="row-justify"
                  @input="onCurrentPercentChange"
                >
                  <md-radio-box
                    v-for="item in percentList"
                    :key="item.name"
                    :name="item.name"
                    :label="item.label"
                    :disabled="item.disabled"
                  ></md-radio-box>
                </md-radio-group>
              </div>
              <div class="btn-group">
                <div class="btn primary plain row-center" @click="onCancelEdit">
                  {{ $t('common.cancel') }}
                </div>
                <div
                  class="btn primary row-center"
                  @click="onUpdateInviteeRate"
                >
                  {{ $t('common.save') }}
                </div>
              </div>
            </div>
          </div>
          <div class="pane">
            <div class="list-wrapper">
              <div class="list-title row-justify">
                <div class="left">{{ $t('rebate.nickname') }}</div>
                <div class="mid">{{ $t('rebate.traded') }}</div>
                <div class="right">{{ $t('rebate.inviteDate') }}</div>
              </div>
              <div class="list-body">
                <md-scroll-view
                  ref="inviteeScroller"
                  auto-reflow
                  :scrolling-x="false"
                  :bouncing="false"
                  @end-reached="loadMoreInvitee"
                >
                  <div class="scroller">
                    <div
                      class="item row-justify"
                      v-for="(item, index) in inviteeList"
                      :key="index"
                    >
                      <div class="left">{{ item.nickname }}</div>
                      <div class="mid">
                        {{ item.traded ? $t('rebate.yes') : $t('rebate.no') }}
                      </div>
                      <div class="right">
                        {{ (item.createdAt * 1000) | formatTime }}
                      </div>
                    </div>
                    <md-scroll-view-more
                      class="load-more"
                      slot="more"
                      :is-finished="isInviteeFinished"
                      :finished-text="$t('common.noMore')"
                      :loading-text="$t('common.loading')"
                    />
                  </div>
                </md-scroll-view>
              </div>
            </div>
          </div>
          <div class="pane">
            <div class="list-wrapper">
              <div class="list-title row-justify">
                <div class="left">{{ $t('rebate.orderInfo') }}</div>
                <div class="mid">{{ $t('rebate.income') }}</div>
                <div class="right">{{ $t('rebate.orderDate') }}</div>
              </div>
              <div class="list-body">
                <md-scroll-view
                  ref="rebateScroller"
                  auto-reflow
                  :scrolling-x="false"
                  :bouncing="false"
                  @end-reached="loadMoreRebate"
                >
                  <div class="scroller">
                    <div
                      class="item row-justify"
                      v-for="(item, index) in rebateList"
                      :key="index"
                    >
                      <div class="left col">
                        <span>{{ item.orderId }}</span>
                        <span>
                          {{ $_t(`rebateType[${item.brokerageType}]`) }}
                        </span>
                      </div>
                      <div class="mid">
                        {{ item.commission }} {{ item.symbol }}
                      </div>
                      <div class="right">
                        {{ (item.brokerageAt * 1000) | formatTime }}
                      </div>
                    </div>
                    <md-scroll-view-more
                      class="load-more"
                      slot="more"
                      :is-finished="isRebateFinished"
                      :finished-text="$t('common.noMore')"
                      :loading-text="$t('common.loading')"
                    />
                  </div>
                </md-scroll-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  RadioBox,
  RadioGroup,
  Toast,
  Skeleton,
  Tabs,
  TabPane,
  ScrollView,
  ScrollViewMore,
  TabBar,
} from 'mand-mobile';
import {
  getCommissionStatistics,
  getCommissionHistory,
  getInviteeList,
} from '@/api/commission.js';
import { postInviteeRate } from '@/api/user.js';
import moment from 'moment';
import { mapState } from 'vuex';
import { Base64 } from 'js-base64';
export default {
  components: {
    TheNavBar,
    [RadioBox.name]: RadioBox,
    [RadioGroup.name]: RadioGroup,
    [Skeleton.name]: Skeleton,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    [TabBar.name]: TabBar,
  },
  filters: {
    formatTime(unix, template = 'YYYY/MM/DD HH:mm') {
      return moment(unix).format(template);
    },
    formatPercent(num) {
      return Math.round(`${num}e4`) / 100;
    },
  },
  data() {
    return {
      current: 'all',
      allCommission: '',
      orderCount: '',
      userCount: '',
      hasRankList: false,
      ranking: '',
      isLoaded: false,
      currentTab: '',
      isEdit: false,
      editUserRate: '',
      editInviteeRate: '',
      currentPercent: '',

      inviteePage: 1,
      inviteeList: [],
      isInviteeFinished: false,
      isInviteeLoaded: false,

      rebatePage: 1,
      rebateList: [],
      isRebateFinished: false,
      isRebateLoaded: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      navLangMain: state => state.navLangMain,
    }),
    tabBarItems() {
      const { $_t } = this;
      return [
        {
          name: 'total',
          label: $_t('total'),
        },
        {
          name: 'invite',
          label: $_t('recommend'),
        },
        {
          name: 'inviteeList',
          label: $_t('inviteList'),
        },
        {
          name: 'rebateList',
          label: $_t('rebateList'),
        },
      ];
    },
    radioList() {
      return [
        {
          name: 'all',
          label: this.$t('rebate.time[0]'),
        },
        {
          name: 'today',
          label: this.$t('rebate.time[1]'),
        },
        {
          name: 'yesterday',
          label: this.$t('rebate.time[2]'),
        },
        {
          name: 'week',
          label: this.$t('rebate.time[3]'),
        },
        {
          name: 'month',
          label: this.$t('rebate.time[4]'),
        },
      ];
    },
    percentList() {
      const total = this.userInfo.userInviteRate;
      return [
        {
          name: '0',
          label: '0%',
          disabled: total <= 0,
        },
        {
          name: '5',
          label: '5%',
          disabled: total <= 0.05,
        },
        {
          name: '10',
          label: '10%',
          disabled: total <= 0.1,
        },
        {
          name: '15',
          label: '15%',
          disabled: total <= 0.15,
        },
        {
          name: '20',
          label: '20%',
          disabled: total <= 0.2,
        },
        {
          name: '25',
          label: '25%',
          disabled: total <= 0.25,
        },
      ];
    },
    inviteLink() {
      return `${window.location.origin}/#/mine/inviteCode?code=${this.userInfo.inviteCode}`;
    },
    userRate() {
      return this.userInfo.userInviteRate * (1 - this.userInfo.inviteeRate);
    },
    inviteeRate() {
      return this.userInfo.userInviteRate * this.userInfo.inviteeRate;
    },
    contentTransformX() {
      let index = this.tabBarItems.findIndex(
        item => item.name === this.currentTab,
      );
      index = index > -1 ? index : 0;
      return `-${index * 100}vw`;
    },
  },
  mounted() {
    this.isLoaded = false;
    Promise.all([
      this.loadStatistics(),
      this.$store.dispatch('updateUserInviteInfo'),
    ])
      .then(() => {
        this.isLoaded = true;
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    $_t(key) {
      return this.$t(`rebate.${key}`);
    },
    onShare() {
      const data = Base64.encode(
        JSON.stringify({
          app_id: '1906a44a-d9eb-4d22-b4c7-b46a85969d5c',
          icon_url: `${window.location.origin}/logo.png`,
          action: this.inviteLink,
          title: this.$t('rebate.inviteTitle'),
          description: 'TIGA',
        }),
      );
      window.location.href = `mixin://send?category=app_card&data=${encodeURIComponent(
        data,
      )}`;
    },
    onTabChanged({ name }) {
      if (name === 'inviteeList' && !this.isInviteeLoaded) {
        this.isInviteeLoaded = true;
        this.loadMoreInvitee().catch(err => {
          Toast.failed(err.message);
        });
      }
      if (name === 'rebateList' && !this.isRebateLoaded) {
        this.isRebateLoaded = true;
        this.loadMoreRebate().catch(err => {
          Toast.failed(err.message);
        });
      }
    },
    onChecked() {
      this.loadStatistics().catch(err => {
        Toast.failed(err.message);
      });
    },
    onEditBtnClick() {
      this.editUserRate = this.userRate;
      this.editInviteeRate = this.inviteeRate;
      this.currentPercent = '' + this.editInviteeRate * 100;
      this.isEdit = true;
    },
    onCancelEdit() {
      this.isEdit = false;
    },
    onCurrentPercentChange(name) {
      this.editInviteeRate = +`${name}e-2`;
      this.editUserRate = +this.userInfo.userInviteRate - this.editInviteeRate;
    },
    onUpdateInviteeRate() {
      Toast.loading(this.$t('common.loading'));
      const rate =
        Math.round(
          (this.editInviteeRate / this.userInfo.userInviteRate) * 10000,
        ) / 10000;
      postInviteeRate(rate)
        .then(() => {
          Toast.hide();
          this.$store.commit('setUserInfo', { inviteeRate: rate });
          this.isEdit = false;
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    loadMoreInvitee() {
      if (this.isInviteeFinished) return;
      return getInviteeList(this.inviteePage).then(data => {
        if (Array.isArray(data.data)) {
          data.data.forEach(item => {
            this.inviteeList.push({
              nickname: item.nickname,
              traded: item.isTrace,
              createdAt: item.createdAt,
            });
          });
        }
        this.inviteePage += 1;
        this.$refs.inviteeScroller &&
          this.$refs.inviteeScroller.reflowScroller();

        if (!data.links || !data.links.next) {
          this.isInviteeFinished = true;
        }
        this.$refs.inviteeScroller &&
          this.$refs.inviteeScroller.finishLoadMore();
      });
    },
    loadMoreRebate() {
      if (this.isRebateFinished) return;
      return getCommissionHistory(this.rebatePage).then(data => {
        if (Array.isArray(data.data)) {
          data.data.forEach(item => {
            this.rebateList.push(item);
          });
        }
        this.rebatePage += 1;
        this.$refs.rebateScroller && this.$refs.rebateScroller.reflowScroller();
        if (!data.links || !data.links.next) {
          this.isRebateFinished = true;
        }
        this.$refs.rebateScroller && this.$refs.rebateScroller.finishLoadMore();
      });
    },
    loadStatistics() {
      const soft = this.current !== 'all' ? this.current : '';
      return getCommissionStatistics(soft).then(data => {
        const d = data.data;
        this.allCommission = d.allCommission || 0;
        this.orderCount = d.orderCount || 0;
        this.userCount = d.userCount || 0;
        this.hasRankList = d.hasRankList;
        this.ranking = d.ranking;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.skeleton-wrapper {
  padding: 4.8vw;
}

.header {
  background: #F8FBFC;
  overflow: hidden;

  .banner {
    width: 100%;
  }

  .ratio {
    display: flex;
    margin: 4.8vw;
    padding: 7.47vw;
    border-radius: 4.8vw;
    background: center / cover linear-gradient(180deg, #294674, #26406A) no-repeat;
  }

  .ratio-left, .ratio-right {
    flex: 1 0 0%;
  }

  .ratio-item + .ratio-item {
    margin-top: 5.07vw;
  }

  .division {
    margin: 0 7.47vw;
    width: 0.27vw;
    background: rgba(#fff, 0.05);
  }

  .ratio-title {
    font-size: 3.2vw;
    line-height: 4.53vw;
    color: #a3b1c8;
  }

  .ratio-content {
    font-size: 5.33vw;
    font-weight: bold;
    line-height: 6.93vw;
    color: #fff;

    .small {
      font-size: 3.2vw;
    }
  }

  .btn {
    width: 26.13vw;
    height: 9.6vw;
    font-size: 3.73vw;
    font-weight: bold;
    background-color: color-primary;
    color: #fff;
    border-radius: 4.8vw;
  }
}

.tab-bar {
  hairline(bottom, #EAF1F3, 0.27vw);
}

.content-wrapper {
  width: 100vw;
  overflow: hidden;
}

.content {
  display: flex;
  width: 400vw;
  height: calc(100vh - 23.46vw - 1px);
  transition: transform 0.1s linear;

  .pane {
    position: relative;
    box-sizing: border-box;
    width: 100vw;
    height: 100%;
    overflow-y: auto;
  }
}

.total-pane {
  padding: 4.8vw;

  .md-radio-group {
    display: flex;
    justify-content: space-between;
  }

  .md-radio-box {
    display: flex;
    align-items: center;
    min-height: 11.73vw;
    border-radius: 1.07vw;
    font-size: 3.2vw;

    >>> .md-tag {
      display: none;
    }
  }

  .detail {
    margin-top: 4.8vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;

    .detail-header {
      padding: 4.8vw 4.8vw 0;

      .detail-header-left {
      }

      .detail-header-right {
        font-size: 2.67vw;

        .num {
          font-size: 4.27vw;
          font-weight: bold;
        }
      }
    }

    .detail-body {
      padding: 4.8vw;
      border-bottom: 0.27vw solid #eaf1f3;
      color: #84969C;
    }

    .detail-footer {
      padding: 4.8vw;

      .strong {
        margin-left: 1.33vw;
      }

      .detail-footer-right {
        color: color-primary;
      }

      .icon {
        margin-right: 1.33vw;
        width: 4.8vw;
        height: 4.8vw;
      }
    }
  }
}

.invite-pane {
  padding: 4.8vw;

  .box-wrapper {
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
  }

  .box {
    padding: 4.8vw;
    font-size: 3.2vw;
    line-height: 4.53vw;
    color: #84969c;

    .item:not(:first-child) {
      margin-top: 2.67vw;
    }

    .item:first-child {
      margin-bottom: 5.6vw;
      color: color-text-base;
    }

    .item-right {
      font-weight: 600;
    }

    .text {
      max-width: 48vw;
      word-ellipsis();
    }

    .icon {
      margin-left: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
      color: color-primary;
    }
  }

  .btn-group {
    display: flex;
    justify-content: flex-end;
    border-top: 0.27vw solid #eaf1f3;
    padding: 4.8vw;

    .btn {
      box-sizing: border-box;
      margin-left: 9.6vw;
      width: 21.33vw;
      height: 9.6vw;
      font-size: 3.2vw;
      font-weight: bold;
      border-radius: 4.8vw;
      border: 0.27vw solid color-primary;

      &.primary {
        background: color-primary;
        color: #fff;
      }

      &.plain {
        background: transparent;
        color: color-primary;
      }
    }
  }

  .info {
    flex: 1 0 0%;

    .info-num {
      font-weight: bold;
      font-size: 5.33vw;
      line-height: 6.93vw;
      color: color-text-base;
    }
  }

  .md-radio-group {
    margin-top: 4.8vw;

    .md-radio-box {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 12vw;
      min-height: 7.47vw;
      border-radius: 1.07vw;
      font-size: 3.73vw;

      >>> .md-tag {
        display: none;
      }
    }
  }
}

.list-wrapper {
  position: relative;
  height: 100%;
  padding: 0 4.8vw;
  font-size: 2.67vw;
  line-height: 4.27vw;
  text-align: left;

  .list-title {
    padding: 4.53vw 0 1.87vw;
    border-bottom: 0.27vw solid #EAF1F3;
  }

  .list-body {
    position: absolute;
    top: 11.2vw;
    left: 0;
    right: 0;
    bottom: 0;
    color: #84969C;
  }

  .item {
    margin: 0 4.8vw;
    padding: 2.13vw 0;
    border-bottom: 0.27vw solid #EAF1F3;
  }

  .left {
    flex: 0 0 30vw;
    word-ellipsis();
  }

  .mid {
    padding-left: 2.13vw;
    flex: 1 0 0%;
  }

  .right {
    box-sizing: border-box;
    padding-left: 2.13vw;
    flex: 0 0 27vw;
  }

  .load-more {
    padding: 2.67vw 0 15vw;
  }
}
</style>
